<template>
    <v-dialog style="overflow-y: hidden;" :class="isMobile ? 'mobile-modal' : 'normal-modal'" v-model="dialogControl">
        <v-card class="dialog-card">
            <v-flex class="inner-card-flex">
                <v-btn @click="dialogControl = false" class="top-right-close-btn" icon>
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
                <v-row class="center">
                    <h2 style="margin-top: 10px; margin-bottom: 10px;">Slider Advertisement</h2>
                </v-row>
                <v-flex style="position: relative; margin-bottom: 5%;">
                    <v-row class="center">
                        <v-col v-if="!hideLabel" :class="positionedTop ? 'position-top' : positionedBottom ? 'position-bottom' : 'position-center'">
                            <h3 :style="`color: ${initObject.labelColor}`">{{ initObject.label }}</h3>
                        </v-col>
                        <v-container class="center image-container">
                            <v-img contain @click="changeImage" title="Edit Advertisement" class="icon-click" :src="initObject.src" />
                            <v-app-bar bottom :collapse="!openActionBar" absolute 
                                color="#00006d" height="70" dark>
                                <v-app-bar-nav-icon @click="openActionBar = !openActionBar"></v-app-bar-nav-icon>
                                <v-toolbar-title v-show="initObject.linkType !== extSiteLink">Ad Actions</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-text-field prefix="https://" style="margin-right: 5px; padding-top: 5px; overflow: hidden;" v-show="openActionBar && initObject.linkType === extSiteLink" hide-details dense outlined label="External Link" v-model="initObject.link"></v-text-field>
                                <v-flex v-show="openActionBar">
                                    <v-btn-toggle background-color="secondary-icon" v-model="initObject.linkType" mandatory borderless>
                                        <v-tooltip top class="secondary-tooltip">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" :class="isMobile ? 'toggle-btn' : ''" v-on="on" :value="companySiteEnum">
                                                    <v-icon class="secondary-icon">fas fa-link</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Link To Company Site</span>
                                        </v-tooltip>
                                        <v-tooltip top class="secondary-tooltip">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" :class="isMobile ? 'toggle-btn' : ''" v-on="on" :value="extSiteLink">
                                                    <v-icon class="secondary-icon">fas fa-external-link-alt</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Link To External Site</span>
                                        </v-tooltip>
                                        <v-tooltip top class="secondary-tooltip">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" :class="isMobile ? 'toggle-btn' : ''" v-on="on" :value="textEnum">
                                                    <v-icon class="secondary-icon">fas fa-sms</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>SMS Signup</span>
                                        </v-tooltip>
                                        <v-tooltip top class="secondary-tooltip">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" :class="isMobile ? 'toggle-btn' : ''" v-on="on" :value="couponEnum">
                                                    <v-icon class="secondary-icon">fas fa-tag</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Coupon</span>
                                        </v-tooltip>
                                    </v-btn-toggle>
                                </v-flex>
                            </v-app-bar>
                        </v-container>
                    </v-row>
                </v-flex>
                <v-row dense class="center horizontal-margin">
                    <v-col cols="6" md="4">
                        <v-text-field v-model="initObject.label" outlined label="Label Text"></v-text-field>
                    </v-col>
                    <v-col cols="6" md="4">
                        <v-select v-model="initObject.position" outlined :items="['Top', 'Center', 'Bottom', 'None']" label="Text Position"></v-select>
                    </v-col>
                </v-row>
                <v-container v-show="initObject.label">
                    <v-row class="center">
                        <v-col cols="4">
                            <h2>Text Color</h2>
                        </v-col>
                    </v-row>
                    <v-row class="center">
                        <v-color-picker
                            v-model="initObject.labelColor"
                            dot-size="9"
                            mode="rgba"
                        ></v-color-picker>
                    </v-row>
                </v-container>
                <v-row class="center section-margin">
                    <site-button
                        :colNum="canActivate || hasChanges ? canActivate && hasChanges ? 4 : 5 : 8"
                        :marginNumber="1"
                        @click-event="deleteAd"
                        iconString="fas fa-minus-circle"
                        btnType="text"
                        text="Delete Ad"
                        colorClasses="secondary-icon"
                        iconColor="primary-icon btn-large"
                    ></site-button>
                    <site-button
                        v-if="canActivate"
                        :colNum="canActivate || hasChanges ? canActivate && hasChanges ? 4 : 5 : 8"
                        @click-event="activate"
                        :iconString="activationIcon"
                        iconType="SVG"
                        btnType="text"
                        text="Activate Ad"
                        colorClasses="secondary-icon"
                        iconColor="primary-icon"
                    ></site-button>
                    <site-button
                        v-if="hasChanges"
                        :colNum="canActivate || hasChanges ? canActivate && hasChanges ? 4 : 5 : 8"
                        @click-event="saveChanges"
                        iconString="far fa-save"
                        iconType="ICON"
                        btnType="text"
                        text="Save Changes"
                        colorClasses="secondary-icon"
                        iconColor="primary-icon save-btn"
                    ></site-button>
                </v-row>
            </v-flex>
            <input @change="imageChanged($event)" type="file" class="carousel-input" accept="image/*" id="dialogFileUpload" ref="dialogFileUpload" />
        </v-card>
    </v-dialog>
</template>

<style lang="scss" scoped>
@import '../../../styles/styles.scss';

.modal-card {
    width: 80% !important;
    max-width: 80%;
}

.horizontal-margin{
    margin-left: 20px !important;
    margin-right: 20px !important;
}

.section-margin{
    margin-top: 20px !important;
    margin-bottom: 40px !important;
}


.image-container{
    overflow: hidden;
    position: relative;
    padding: 0px;
    max-height: 600px;
    max-width: 700px;
    border-radius: 5%;
    margin: 0px 2.5%;
    background-color: lightgrey;
}

.toggle-btn{
    min-width: 38px !important;
    padding: 0px !important;
    border-radius: 5px;
}

.position-top{
    position: absolute; 
    top: 0; 
    z-index: 1;
}

.position-center{
    position: absolute;
    z-index: 1;
}

.position-bottom{
    position: absolute; 
    bottom: 0; 
    z-index: 1;
}

.carousel-input{
    display: none;
}

::v-deep .v-dialog{
    overflow-y: hidden !important;
    border-radius: 15px;
    height: 90%;
    max-height: 90% !important;
    max-width: 90%;
}

.dialog-card{
    height: 100%;
    overflow-y: hidden;
}

.icon-click{
    cursor: pointer;
    background-size: 100%;
}

.inner-card-flex{
    height: 100%; 
    overflow-y: auto; 
    margin-left: 0; 
    margin-right: 0;
}
</style>

<script>
import LinkTypes from '../../../assets/Enums/LinkType';
import AdvertisementType from '../../../assets/Enums/AdvertisementType'
import SiteButton from '../SiteButton';
import { nanoid } from 'nanoid';
import TrafficType from '../../../assets/Enums/TrafficType';

const currentDate = new Date(),
    trafficKey = currentDate.toISOString().substring(0, 7);

export default {
    name: 'ad-config-dialog',
    model: {
        prop: 'adObject',
        event: 'change'
    },
    components: {
        'site-button': SiteButton
    },
    props: {
        adObject: Object,
        showDialog: {
            type: Boolean,
            default: false,
        },
        index: Number,
        hasChanges: {
            type: Boolean,
            default: null
        },
    },
    data: () => ({
        initObject: 
        {
            localId: nanoid(6),
            partnerId: '',
            label: 'slide 1 name',
            src: 'https://i.insider.com/5d96062cb513f41cc2258484?width=1136&format=jpeg',
            srcFile: null,
            type: AdvertisementType.SLIDER,
            linkType: LinkTypes.SiteLink,
            link: '',
            labelColor: '',
            position: null,
            isActive: true,
            targetMarket: {
                ageStart: 21,
                ageEnd: 70,
                genders: [],
                activeAreas: [],
                keyWords: [],
            },
            traffic: {
                entries: [{ term: trafficKey, day: currentDate.getDate(), traffic: 0, trafficType: TrafficType.SliderAd }],
                trafficType: TrafficType.SliderAd
            }
        },
        openActionBar: false,
        windowWidth: null,
        hasBeenChanged: false
    }),
    updated() {
        this.initObject = this.adObject;
        if(!this.initObject.src){
            this.initObject.src = require('../../../assets/Add-Image-Placeholder.png');
        }
    },
    mounted(){
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
        });
        this.windowWidth = window.innerWidth;
        this.initObject.partnerId = this.$store.getters.partnerId;
    },
    methods: {
        imageChanged(event){
            const file = event.target.files[0];
            this.initObject.srcFile = file;
            this.initObject.src = URL.createObjectURL(file);
        },
        activate(){
            this.$emit('activate', this.index);
        },
        deleteAd(){
            this.$emit('delete', this.index);
        },
        saveChanges(){
            this.$emit('save', this.initObject);
        },
        changeImage(){
            this.$refs['dialogFileUpload'].click();
        }
    },
    computed: {
        dialogControl: {
            get() {
                return this.showDialog
            },
            set(newVal) {
                this.$emit('set-dialog-control', newVal)
            },
        },
        isMobile() {
            return this.windowWidth <= 760
        },
        positionedTop(){
            return this.initObject.position === 'Top';
        },
        positionedBottom(){
            return this.initObject.position === 'Bottom';
        },
        positionedCentered(){
            return this.initObject.position === 'Center';
        },
        hideLabel(){
            return this.initObject.position === 'None';
        },
        textEnum() {
            return LinkTypes.Text;
        },
        couponEnum(){
            return LinkTypes.Coupon;
        },
        extSiteLink() {
            return LinkTypes.ExtLink;
        },
        companySiteEnum() {
            return LinkTypes.SiteLink;
        },
        activationIcon(){
            return require('../../../assets/Activate-Icon.svg');
        },
        deleteIcon(){
            return require('../../../assets/Delete-Ad.svg');
        },
        canActivate(){
            return this.$store.state.tempAdvertisements.findIndex(s => s && s.localId === this.initObject.localId) > -1 && !this.initObject.isActive;
        },
    },
}
</script>